/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import initHeader from "components/header/header";
import button from "components/buttons/buttons";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import cmsContent from "components/cms-content/cms-content";
import heroSlider from "imComponents/hero-slider/hero-slider";
import heroImage from "imComponents/hero-image/hero-image";
import titleBox from "components/title-box/title-box";
import textImgVar from "imComponents/text-img-var/text-img-var";
import contactForm from "components/contact-form/contact-form";
import cardsTextBg from "components/cards-text-bg/cards-text-bg";
import accordion from "imComponents/accordion/accordion";
import textOnBg from "imComponents/text-on-bg/text-on-bg";
import twoColSlider from "components/two-col-slider/two-col-slider";
import smallImgText from "components/small-img-text/small-img-text";
import timelineFilters from "components/timeline-filters/timeline-filters";
import footer from "components/footer/footer";
import textIframe from "components/text-iframe/text-iframe";
import cardNews from "components/cards/card-news";
import sliderNews from "components/slider-news/slider-news";
import customAccordion from "components/custom-accordion/custom-accordion";
import twoColCustomAccordion from "components/two-col-custom-accordion/two-col-custom-accordion";
import timelineSlider from "components/timeline-slider/timeline-slider";
import animateIn from "animations/animate-in/animate-in";
import sliderBanner from "components/slider-banner/slider-banner";
import textImgFix from "imComponents/text-img-fix/text-img-fix";
import carouselGallery from "imComponents/carousel-gallery/carousel-gallery";

//--------------------------------------------------------------------//
//
// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector("body.wp-admin")) {
        initHeader();
        heroSlider();
    }
    accordion();
    timelineFilters();
    sliderNews();
    twoColSlider();
    timelineSlider();
    animateIn();
    sliderBanner();
    carouselGallery();
}
if (document.querySelector("body.wp-admin")) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction("render_block_preview", initBlock);
        }
    })(jQuery);
}
initAllComponents();
//--------------------------------------------------------------------//
